// extracted by mini-css-extract-plugin
export var cardTitle = "_hw-1";
export var commentBubble = "_hw-e";
export var commentForm = "_hw-a";
export var commentInput = "_hw-b";
export var commentLabel = "_hw-d";
export var commentPrompt = "_hw-9";
export var csatCard = "_hw-0";
export var feedbackSection = "_hw-7";
export var starDisabled = "_hw-6";
export var starEmpty = "_hw-5";
export var starFilled = "_hw-4";
export var starWrapper = "_hw-3";
export var starsContainer = "_hw-2";
export var submittedComment = "_hw-c";
export var thankYouText = "_hw-8";